export default {

  methods: {
    getTitle (section) {
      switch (section.type) {
        case 'programlist':
          return '프로그램'
        case 'vodlist':
          return 'VOD'
        case 'livelist':
          return 'LIVE'
        case 'cliplist':
          return 'TV컷'
        case 'movielist':
          return '영화'
        case 'themelist':
          return '에디터Pick'
        default:
          return '프로그램'
      }
    },
    getCategoryByDetailType (type) {
      let category = ''
      switch (type) {
        case 'programlist' :
          category = 'program'
          break
        case 'vodlist' :
          category = 'vod'
          break
        case 'livelist' :
          category = 'live'
          break
        case 'cliplist' :
          category = 'clip'
          break
        case 'themelist' :
          category = 'theme'
          break
        case 'movielist' :
          category = 'movie'
          break
      }
      return category
    }
  }
}
